/**
 * Minaccia — coreBOS `Threats` (69x) on evo-gdpr.evolutivo.it.
 * Harvested from evo-mcp-limitless@origin/evo-policies by scripts/harvest/gen_descriptors.py.
 * Frameworks: gdpr,nis2. Type sources per field: docs/harvest-report.md.
 * Regenerate instead of hand-editing; hand edits belong in the generator's SPEC.
 */
export const threatDescriptor = {
    slug: 'cmp_threat',
    kind: 'document',
    label: { singular: 'Minaccia', plural: 'Minacce' },
    table: 'compliance_threat',
    idStrategy: 'sha256',
    fields: [
        { name: 'threatsname', type: 'text', label: 'Nome Minaccia', required: true },
        { name: 'threat_id', type: 'text', label: 'Codice' },
        { name: 'framework_tags', type: 'text', label: 'Framework tags' },
        { name: 'category', type: 'text', label: 'Categoria' },
        { name: 'type_of_threats', type: 'text', label: 'Tipo' },
        { name: 'importance_level', type: 'text', label: 'Importance level' },
        { name: 'thriskscore', type: 'number', label: 'Risk Score' },
        { name: 'residual_probability', type: 'text', label: 'Residual probability' },
        { name: 'residual_impact', type: 'text', label: 'Residual impact' },
        { name: 'treatment', type: 'text', label: 'Treatment' },
        { name: 'treatment_justification', type: 'text', label: 'Treatment justification' },
        { name: 'active', type: 'text', label: 'Active' },
        { name: 'description', type: 'text', label: 'Descrizione' },
    ],
    relations: [
        { name: 'company', kind: 'belongsTo', target: 'account', toEntitySpine: true },
        { name: 'assigned_user', kind: 'belongsTo', target: 'user', toEntitySpine: true },
    ],
    behaviors: { ownership: true, audit: true, softDelete: true, tenantScoped: true },
    ui: { mode: 'generated', icon: 'WarningOutlined', navGroup: 'Rischi' },
};
